import React from "react";
import { useTranslation } from "react-i18next";
import ImageGallery from "react-image-gallery";

interface Props {
  images: any[];
  title?: string;
}

function MediaGallery({ images, title = "Media Gallery" }: Props) {
  const {t} = useTranslation()
  return images.length ? (
    <>
      <h1 className="title">{t('details:addonDetails.mediaGallery')}</h1>
      <ImageGallery
        autoPlay
        items={images}
        slideDuration={500}
        slideInterval={15000}
        showFullscreenButton={false}
        showPlayButton={false}
      />
    </>
  ) : null;
}

export default MediaGallery;
